export interface IHardToPlaceDonor {
    donorCenterId: number,
    donorCenterAlias: string,
    donorId: number,
    donorAlias: string,
    entitySurgeryDate: string | null,
    ageAtTimeOfTransplant: number,
    whichKidneyDonated: string,
    numberOfArteries: number,
    creatinineClearance: number,
    donorBloodType: string,
    isRealTimeSwapFailure: boolean,

    meetsAgeCriteria: boolean,
    meetsLeftAnatomyCriteria: boolean,
    meetsRightAnatomyCriteria: boolean,
    meetsCCCriteria: boolean,
    meetsABOCriteria: boolean,
    transplantDate: string
}